import { ServiceType } from './contractor';

export enum SetMenuCourse {
    Starter = 'starter',
    Main = 'main',
    Side = 'side',
    Dessert = 'dessert',
    Drink = 'drink',
}

export enum BookingSetMenuStatus {
    Active = 'active',
    Cancelled = 'cancelled',
    Declined = 'declined',
    Completed = 'completed',
    PendingBooking = 'pendingBooking',
}
